export default "__VITE_ASSET__d04b47de__"